var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8Figma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface93186866"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196079%,29.019609%,9.803922%)",
      fillOpacity: 1
    },
    d: "M 26.28125 16.019531 L 17.160156 16.019531 C 12.753906 16.019531 9.179688 12.445312 9.179688 8.039062 C 9.179688 3.632812 12.753906 0.0585938 17.160156 0.0585938 L 26.28125 0.0585938 Z M 26.28125 16.019531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(48.627451%,30.19608%,100%)",
      fillOpacity: 1
    },
    d: "M 25.140625 31.980469 L 17.160156 31.980469 C 12.753906 31.980469 9.179688 28.40625 9.179688 24 C 9.179688 19.59375 12.753906 16.019531 17.160156 16.019531 L 25.140625 16.019531 Z M 25.140625 31.980469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(40.000001%,73.333335%,41.568628%)",
      fillOpacity: 1
    },
    d: "M 17.160156 47.941406 C 12.753906 47.941406 9.179688 44.367188 9.179688 39.960938 C 9.179688 35.554688 12.753906 31.980469 17.160156 31.980469 L 25.140625 31.980469 L 25.140625 39.960938 C 25.140625 44.367188 21.566406 47.941406 17.160156 47.941406 Z M 17.160156 47.941406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,43.921569%,26.274511%)",
      fillOpacity: 1
    },
    d: "M 33.121094 16.019531 L 25.140625 16.019531 L 25.140625 0.0585938 L 33.121094 0.0585938 C 37.527344 0.0585938 41.101562 3.632812 41.101562 8.039062 C 41.101562 12.445312 37.527344 16.019531 33.121094 16.019531 Z M 33.121094 16.019531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(16.078432%,71.372551%,96.470588%)",
      fillOpacity: 1
    },
    d: "M 41.101562 24 C 41.101562 28.40625 37.527344 31.980469 33.121094 31.980469 C 28.710938 31.980469 25.140625 28.40625 25.140625 24 C 25.140625 19.59375 28.710938 16.019531 33.121094 16.019531 C 37.527344 16.019531 41.101562 19.59375 41.101562 24 Z M 41.101562 24 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Figma);
export default __webpack_public_path__ + "static/media/icons8-figma.1a2546c1235af05e01234db8e1ae6a2f.svg";
export { ForwardRef as ReactComponent };